import { toastr } from "react-redux-toastr";

// Tells the admin that an invite or a password link was mailed. mailed is false when
// the backend has no mailPass and only printed the mail (a local run): nobody got
// it, and the link is in the backend's log. An older backend does not say.
export const mailToast = (email, what, mailed) => {
  if (mailed === false) {
    toastr.warning(
      `${email} хаяг руу ${what} илгээгдсэнгүй: серверт mailPass тохируулаагүй тул холбоос серверийн log-д хэвлэгдлээ`
    );
  } else {
    toastr.success(`${email} хаяг руу ${what} илгээлээ`);
  }
};
